<p-card *ngIf="processo !== undefined">
  <div class="p-fluid">
    <div class="p-field">
      <ul class="list-group" *ngIf="processo?.instancia">
        <li class="list-title-color">
          <span class="label label-warning" style="font-size: 15px">
            <span *ngIf="processo?.instancia">{{processo?.instancia | dominio: 'getFonteDadosInstanciaItens'}}</span>
          </span>
          <span *ngIf="processo?.dataExclusao" class="label label-danger" [pTooltip]="processo?.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'" style="font-size: 15px; margin-left: 4px;">
            <span>Excluído</span>
          </span>
        </li>
        <li>
          <span class="numero highlight">{{processo?.id}} - {{processo?.numero}} </span>
          <span [ngClass]="getClassePeticaoAtribuida(processo)" class="peticao-inicial-titulo"></span>
        </li>
        <li>
          <span class="p-text-bold">Origem Id: </span>
          {{processo?.fonteDados.nome}} - {{processo?.origemId}}
        </li>
        <li *ngIf="isSegundoGrau()">
          <span class="p-text-bold">Colegiado: </span>
          <a [routerLink]="['/orgaoJulgadorColegiadoLocal/visualizar/', processo?.distribuicaoAtual?.orgaoJulgadorColegiadoLocal?.id]">
            {{processo?.distribuicaoAtual?.orgaoJulgadorColegiadoLocal?.nome}}
          </a>
        </li>
        <li>
          <span *ngIf="processo?.distribuicaoAtual?.orgaoJulgador.id === -1">
            <span class="p-text-bold">Órgão julgador: </span>
            <a [routerLink]="['/orgaoJulgadorLocal/visualizar/', processo?.distribuicaoAtual?.orgaoJulgadorLocal?.id]">
              {{processo?.distribuicaoAtual?.orgaoJulgadorLocal.nome}}
            </a>
          </span>
          <span *ngIf="processo?.distribuicaoAtual?.orgaoJulgador.id !== -1">
            <span class="p-text-bold"> Órgão julgador: </span>
            <a [routerLink]="['/orgaoJulgador/visualizar/', processo?.distribuicaoAtual?.orgaoJulgador.id]">
                  {{processo?.distribuicaoAtual?.orgaoJulgador.nome}}
            </a>
          </span>
        </li>
        <li>
          <span class="p-text-bold"> Classe: </span>
          <a [routerLink]="['/classe/visualizar/', processo?.classeAtual?.classe.id]">
            {{processo?.classeAtual?.classe?.id}} - {{processo?.classeAtual?.classe?.descricao}}
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="p-grid p-fluid" *ngIf="mostrarComandoProcesso">
    <div class="p-col-3">
      <p-splitButton label="Sincronizar" [model]="sincronizarItens"></p-splitButton>
    </div>
    <div class="p-col-3">
        <p-splitButton label="Ações" [model]="acoesItens"></p-splitButton>
    </div>
  </div>
  <div>

    <p-tabView [(activeIndex)]="tabViewIndex" (onChange)="onChangeTabView(true)">
      <p-tabPanel header="Linha do tempo" leftIcon="pi pi-sitemap">
        <app-processo-linha-tempo [processo]="processo"></app-processo-linha-tempo>
      </p-tabPanel>
      <p-tabPanel header="Dados" leftIcon="pi pi-book">
        <p-tabView>
          <p-tabPanel header="Capa processual" *ngIf="processo?.instancia">
        <div class="p-grid m-b-5 ">
          <div class="p-col-4 p-text-bold">Instância:</div>
          <div class="p-col-8">{{processo.instancia | dominio: 'getFonteDadosInstanciaItens'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Data de ajuizamento:</div>
          <div class="p-col-8">{{processo.dataAjuizamento | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Data de exclusão:</div>
          <div class="p-col-8">{{processo.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Situação migração:</div>
          <div class="p-col-8">{{processo.situacaoMigracao | dominio: 'getSituacaoMigracaoItens'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Justiça gratuita:</div>
          <div class="p-col-8">{{processo.justicaGratuita ? 'Sim' : 'Não' }}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Nível de sigilo:</div>
          <div class="p-col-8">{{processo.nivelSigilo | dominio: 'getNivelSigiloItens'}} </div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Liminar:</div>
          <div class="p-col-8">{{processo.liminar ? 'Sim' : 'Não'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Valor da causa:</div>
          <div class="p-col-8"><span *ngIf="processo.valorCausa !== null">{{processo.valorCausa |
            currency:'BRL'}}</span></div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Competência:</div>
          <div class="p-col-8">
            <a [routerLink]="['/competencia/visualizar/', processo.competencia?.id]">
              {{processo.competencia?.nome}}
            </a>
          </div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Tipo de justiça:</div>
          <div class="p-col-8">{{processo.tipoJustica | dominio: 'getTipoJusticaItens'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Natureza:</div>
          <div class="p-col-8">{{processo.natureza | dominio: 'getNaturezaItens'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Data da comunicação de sincronização:</div>
          <div class="p-col-8">{{processo.dataComunicacaoSincronizacao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>

        <div class="p-grid m-b-5" *ngIf="processo.dataAnalisePeticaoInicialAutomatica">
          <div class="p-col-4 p-text-bold">Análise da petição inicial - Automática</div>
          <div class="p-col-8">{{processo.dataAnalisePeticaoInicialAutomatica | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>

        <div class="p-grid m-b-5" *ngIf="processo.dataAnalisePeticaoInicialManual">
          <div class="p-col-4 p-text-bold">Análise da petição inicial - Manual:</div>
          <div class="p-col-8">
            {{processo.analisePeticaoInicialUsuario.id}} - {{processo.analisePeticaoInicialUsuario.nome}}<br />
            {{processo.dataAnalisePeticaoInicialManual | date: 'dd/MM/yyyy HH:mm:ss'}}
          </div>
        </div>

        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Última indexação de situações:</div>
          <div class="p-col-8">{{processo.dataUltimaIndexacaoSituacoes | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Última sincronização de documentos:</div>
          <div class="p-col-8">{{processo.dataUltimaSincronizacaoDocumentos | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Última sincronização de metadados:</div>
          <div class="p-col-8">{{processo.dataUltimaSincronizacaoMetadados | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Última sincronização de movimentos:</div>
          <div class="p-col-8">{{processo.dataUltimaSincronizacaoMovimentos | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid m-b-5">
          <div class="p-col-4 p-text-bold">Última sincronização de partes:</div>
          <div class="p-col-8">{{processo.dataUltimaSincronizacaoPartes | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        </p-tabPanel>
          <p-tabPanel header="Identificação de petição inicial">
            <app-processo-identificacao-peticao-inicial-dados [processoIdentificacaoPeticaoInicial]="processoIdentificacaoPeticaoInicial" [processo]="processo">
            </app-processo-identificacao-peticao-inicial-dados>
          </p-tabPanel>
        </p-tabView>
      </p-tabPanel>
      <p-tabPanel header="Assuntos" leftIcon="pi pi-list">
        <div class="p-fluid p-grid">
          <div class="p-col-12 p-lg-12">
            <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsAssunto && dsAssunto.restricoes">
              <div class="p-fluid p-formgrid p-grid" (keyup)="dsAssunto.onEnterPesquisar($event)">
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-number label="Id" [restricao]="dsAssunto.restricoes.atributo('id')"></m-restricao-number>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Origem Id" [restricao]="dsAssunto.restricoes.atributo('origemId')"></m-restricao-string>
                </div>
                <div class="p-field p-col-12">
                  <m-restricao-string label="Descrição"  [restricao]="dsAssunto.restricoes.atributo('assunto.descricao')"></m-restricao-string>
                </div>
              </div>
              <ng-template pTemplate="footer">
                <div class="p-fluid p-grid" style="padding-top: 1rem;">
                  <div class="p-field p-col-6">
                    <button pButton label="Pesquisar" (click)="dsAssunto.pesquisar()"></button>
                  </div>
                  <div class="p-field p-col-6">
                    <button pButton class="p-button-secondary" label="Limpar" (click)="dsAssunto.limpar()"></button>
                  </div>
                </div>
              </ng-template>
            </p-panel>
          </div>
        </div>
        <p-table
          *ngIf="dsAssunto !== undefined"
          [multiSortMeta]="dsAssunto.ordenacoes"
          [value]="dsAssunto.entidades"
          [totalRecords]="dsAssunto.total"
          (onLazyLoad)="dsAssunto.carregar($event)"
          [lazy]="true"
          [(rows)]="dsAssunto.registros"
          [paginator]="true"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,25,50,100]"
          paginatorPosition = "bottom"
          responsive="true"
          sortMode="multiple"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped"
          emptyMessage="Nenhum registro encontrado">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
              <th>Descrição</th>
              <th class="p-text-center" style="width: 8rem;"> Principal</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-processoAssunto>
            <tr>
             <td class="p-text-center">
               <app-id
                 [id]="processoAssunto.id"
                 [origemId]="processoAssunto.origemId"
               ></app-id>
              </td>
              <td>
                <div>
                  <a [routerLink]="['/assunto/visualizar/', processoAssunto.assunto.id]"> {{processoAssunto.assunto.descricao}}</a>
                  <br />
                  <div *ngIf="processoAssunto.assunto.id === -1 && processoAssunto.assuntoRecebidoId !== null">Id recebido: {{processoAssunto.assuntoRecebidoId}}</div>
                </div>
                <span *ngIf="processoAssunto.dataExclusao"
                      style="color: #000000; font-style: italic; font-size: 0.8em;">Excluído em: {{processoAssunto.dataExclusao
                  | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
              </td>
              <td class="p-text-center">
                <span [ngClass]="processo.assuntoPrincipal?.id === processoAssunto.assunto?.id ? 'badge badge-success' : 'badge badge-danger'">
                  {{ processo.assuntoPrincipal?.id === processoAssunto.assunto?.id | dominio: 'getSimNaoItens' }}
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Classes" leftIcon="pi pi-sitemap">
        <p-table [value]="processo?.historicoClasses"
                 responsive="true"
                 responsiveLayout="scroll"
                 [sortField]="'dataInicio'"
                 [sortOrder]="-1"
                 styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
              <th>Data Início</th>
              <th>Data Fim</th>
              <th>Classe</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-processoClasse>
            <tr>
              <td class="p-text-center">
                <app-id
                  [id]="processoClasse.id"
                  [origemId]="processoClasse.origemId">
                </app-id>
              </td>
              <td>{{processoClasse.dataInicio | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
              <td>{{processoClasse.dataFim | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
              <td>
                <a [routerLink]="['/classe/visualizar', processoClasse.classe.id]"> {{processoClasse.classe.descricao}} </a>
                <br />
                <div *ngIf="processoClasse.classe.id === -1 && processoClasse.classeRecebidaId !== null">Id recebido: {{processoClasse.classeRecebidaId}}</div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Distribuições" leftIcon="pi pi-share-alt">
        <p-table [value]="processo?.historicoDistribuicoes"
                 responsive="true"
                 responsiveLayout="scroll"
                 [sortField]="'dataInicio'"
                 [sortOrder]="-1"
                 styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
              <th>Data Início</th>
              <th>Data Fim</th>
              <th *ngIf="isSegundoGrau()">Colegiado</th>
              <th>Órgão Julgador</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-processoDistribuicao>
            <tr>
              <td class="p-text-center">
                <app-id
                  [id]="processoDistribuicao.id"
                  [origemId]="processoDistribuicao.origemId">
                </app-id>
              </td>
              <td>{{processoDistribuicao.dataInicio | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
              <td>{{processoDistribuicao.dataFim | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
              <td *ngIf="isSegundoGrau()">
                <a [routerLink]="['/orgaoJulgadorColegiadoLocal/visualizar/', processoDistribuicao?.orgaoJulgadorColegiadoLocal.id]">
                  {{processoDistribuicao?.orgaoJulgadorColegiadoLocal?.nome}}
                </a>
              </td>
              <td>
                <span *ngIf="processoDistribuicao.orgaoJulgador.id === -1">
                   <a [routerLink]="['/orgaoJulgadorLocal/visualizar/', processoDistribuicao.orgaoJulgadorLocal.id]">
                     {{processoDistribuicao.orgaoJulgadorLocal.nome}}
                  </a>
                </span>
                <span *ngIf="processoDistribuicao.orgaoJulgador.id !== -1">
                   <a [routerLink]="['/orgaoJulgador/visualizar/', processoDistribuicao.orgaoJulgador.id]">
                     {{processoDistribuicao.orgaoJulgador.nome}}
                  </a>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Documentos" leftIcon="pi pi-id-card">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-col-12 p-lg-12">
            <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsDocumento && dsDocumento.restricoes">
              <div class="p-fluid p-formgrid p-grid" (keyup)="dsDocumento.onEnterPesquisar($event)">
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-number label="Id" [restricao]="dsDocumento.restricoes.atributo('id')"></m-restricao-number>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Origem Id" [restricao]="dsDocumento.restricoes.atributo('origemId')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Nome" [restricao]="dsDocumento.restricoes.atributo('nome')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Tipo" [restricao]="dsDocumento.restricoes.atributo('tipoProcessoDocumentoLocal.nome')"></m-restricao-string>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-temporal label="Juntado em" [restricao]="dsDocumento.restricoes.atributo('dataJuntada')"></m-restricao-temporal>
                </div>
                <div class="p-field p-col-6">
                  <label class="m-l-8">Tipo de arquivo:</label>
                  <p-dropdown
                    placeholder="Selecione..." [options]="tipoArquivoItens"
                    [(ngModel)]="dsDocumento.restricoes.atributo('arquivo.tipo').valor"
                    class="p-dropdown-p"
                    filter="true">
                  </p-dropdown>
                </div>
              </div>
              <ng-template pTemplate="footer">
                <div class="p-fluid p-grid" style="padding-top: 1rem;">
                  <div class="p-field p-col-6">
                    <button pButton label="Pesquisar" (click)="dsDocumento.pesquisar()"></button>
                  </div>
                  <div class="p-field p-col-6">
                    <button pButton class="p-button-secondary" label="Limpar" (click)="dsDocumento.limpar()"></button>
                  </div>
                </div>
              </ng-template>
            </p-panel>
          </div>
        </div>
        <p-card>
          <div class="p-card-title">
          <span *ngIf="carregandoDocumentos">
              <em class="pi-fw pi pi-spin pi-spinner"></em>
          </span>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-md-3">
              <div class="card">
                <div class="p-text-center titulo-documentos-aba">Documentos</div>
                <p-table
                  *ngIf="dsDocumento !== undefined"
                  [multiSortMeta]="dsDocumento.ordenacoes"
                  [value]="dsDocumento.entidades"
                  [totalRecords]="dsDocumento.total"
                  (onLazyLoad)="dsDocumento.carregar($event)"
                  [columns]="cols"
                  [scrollable]="true"
                  [(rows)]="dsDocumento.registros"
                  scrollHeight="550px"
                  currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} documentos"
                  [rowsPerPageOptions]="[10,25,50,100]"
                  paginatorPosition = "bottom"
                  pageLinks = "2"
                  [showCurrentPageReport]="true"
                  [paginator]="true"
                  responsive="true"
                  responsiveLayout="scroll"
                  [lazy]="true"
                  styleClass="p-datatable-striped"
                  emptyMessage="Nenhum registro encontrado">

                  <ng-template pTemplate="body" let-rowData let-columns="documento" let-documento>
                    <tr style="height:34px">
                      <td>
                        <div  class="p-col-12 documento-pai p-text-break"
                              [ngClass]="{'documento-selecionado': documento == processoDocumento}"
                              (click)="selecionarProcessoDocumento(documento)">
                          <div>
                      <span class="pi"
                            [ngClass]="{'pi-exclamation-triangle pendente': !documento.processado, 'pi-file processado': documento.processado}"></span>
                            {{documento.nome}}
                            <span [ngClass]="getClassePeticaoAtribuida(processo)"
                                  *ngIf="processo?.peticaoInicial && processo?.peticaoInicial.id === documento.id">
                               <button pButton pRipple
                                       type="button"
                                       icon="pi pi-file"
                                       class="p-button-rounded p-button-success"
                                       pTooltip="Petição Inicial"
                                       style="float: right;">
                              </button>
                           </span>
                          </div>
                          <div style="font-style: italic; font-size: 0.8em;"><span class="p-text-bold">Id: </span>
                            {{documento.id}} - <span class="p-text-bold">Origem Id: </span>
                            {{documento.origemId}}</div>
                          <div style="font-style: italic; font-size: 0.8em;"><span class="p-text-bold">Juntado em: </span>
                            {{documento.dataJuntada | date:
                              'dd/MM/yyyy HH:mm:ss' }}</div>
                          <div style="color: red; font-style: italic; font-size: 0.8em;" *ngIf="documento.excluido">Excluído em:
                            {{documento.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
                        </div>

                        <ul class="documentos-filhos">
                          <li class="documento-filho" *ngFor="let documentoFilho of documento.filhos"
                              [ngClass]="{'documento-selecionado': documentoFilho == processoDocumento}">
                            <div class="p-col-12" (click)="selecionarProcessoDocumento(documentoFilho)">
                              <div>
                        <span class="fa"
                              [ngClass]="{'pi-exclamation-triangle pendente': !documentoFilho.processado, 'pi-paperclip processado': documentoFilho.processado}"></span>
                                <div class="p-text-break">{{documentoFilho.nome}}</div>
                                <span [ngClass]="getClassePeticaoAtribuida(processo)"
                                      *ngIf="processo.peticaoInicial !== undefined && processo.peticaoInicial.id === documentoFilho.id"></span>
                              </div>
                              <div style="font-style: italic; font-size: 0.8em;">Id: {{documentoFilho.id}} - Origem Id:
                                {{documentoFilho.origemId}}</div>
                            </div>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="6"> Não há documentos a serem exibidos.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
            <div class="p-col-12 p-md-9">
              <div class="p-grid p-fluid" *ngIf="processoDocumento === undefined">
                <div class="p-col-12">
                  <button pButton type="button" class="p-button-raised p-button-rounded"
                          label="Definir Petição Inicial Ausente" (click)="atribuirPeticaoInicialAusente()"></button>
                </div>
              </div>

              <div *ngIf="processoDocumento !== undefined">

                <app-processo-documento-comparacao-texto-original #dlgProcessoDocumentoComparacao
                                                                  [processoDocumento]="processoDocumento">
                </app-processo-documento-comparacao-texto-original>

                <div class="p-d-flex p-jc-center">
                  <div class="p-mr-2"    *ngIf="permissaoProcessarArquivoEstruturaBtn">
                    <button pButton type="button" class="p-button-raised p-button-rounded"
                            label="Processar arquivo estrutura" (click)="processarArquivoEstrutura()"
                            *ngIf="!processoDocumento.processado"></button>
                    <button pButton type="button" class="p-button-raised p-button-rounded"
                            label="Reprocessar arquivo estrutura" (click)="reprocessarArquivoEstrutura()"
                            *ngIf="processoDocumento.processado"></button>
                  </div>
                  <div class="p-mr-2">
                    <button pButton type="button" class="p-button-raised p-button-rounded" label="Comparar Texto/Original"
                            (click)="dlgProcessoDocumentoComparacao.visualizar()"
                            [disabled]="!processoDocumento.processado"></button>
                  </div>
                  <div class="p-mr-2" *ngIf="atribuirPeticaoInicialBtn">
                    <button pButton type="button" class="p-button-raised p-button-rounded"
                            label="Definir como Petição Inicial" (click)="atribuirPeticaoInicial()"></button>
                  </div>
                  <div class="p-mr-2" *ngIf="atribuirPeticaoInicialAusenteBtn">
                    <button pButton type="button" class="p-button-raised p-button-rounded"
                            label="Definir Petição Inicial Ausente" (click)="atribuirPeticaoInicialAusente()"></button>
                  </div>
                </div>
                <div style="margin-top: 1em"></div>
                <p-tabView [(activeIndex)]="tabViewDocumentosIndex" (onChange)="onChangeTabViewDocumentos()">

                  <p-tabPanel header="Dados">
                    <div class="p-grid">
                      <div class="p-col-4 p-text-bold">Id:</div>
                      <div class="p-col-8">{{processoDocumento.id}}</div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-4 p-text-bold">Nome:</div>
                      <div class="p-col-8">{{processoDocumento.nome}}</div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-4 p-text-bold">Origem Id:</div>
                      <div class="p-col-8">{{processoDocumento.origemId}}</div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-4 p-text-bold">Data de juntada:</div>
                      <div class="p-col-8">{{processoDocumento.dataJuntada | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
                    </div>
                    <div class="p-grid" *ngIf="processoDocumento.excluido">
                      <div class="p-col-4">Data da exclusão: </div>
                      <div class="p-col-8">{{processoDocumento.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-4 p-text-bold">Tipo:</div>
                      <div class="p-col-8">
                        <a href="tipoProcessoDocumento/visualizar/{{processoDocumento.tipo.id}}">
                          {{processoDocumento.tipo.id}} - {{processoDocumento.tipo.nome}}
                        </a>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-4 p-text-bold">Tipo de arquivo: </div>
                      <div class="p-col-8">{{processoDocumento.categoriaArquivo}} - {{processoDocumento.tipoArquivo}}
                      </div>
                    </div>
                    <div class="p-grid" *ngIf="processoDocumento?.signatarios?.length > 0">
                      <div class="p-col-4 p-text-bold">Signatários: </div>
                      <div class="p-col-8">
                        <li *ngFor="let signatario of processoDocumento.signatarios">
                          <a href="/pessoa/visualizar/{{signatario.signatario.id}}">{{signatario.signatario.nome}}</a>
                        </li>
                      </div>
                    </div>
                  </p-tabPanel>

                  <p-tabPanel header="Arquivo" [disabled]="!processoDocumento.processado">
                    <div *ngIf="processoDocumento.processado">
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Id: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.id}}</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Tipo: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.categoria}} - {{processoDocumento.arquivo.tipo}}
                        </div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Hash: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.hash}}</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Tamanho do arquivo original: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.tamanho / 1024}}kb</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Tamanho do arquivo texto: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.tamanhoTexto}}bytes</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4">Transformações: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.transformacoes}}</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Data do processamento: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.dataProcessamento | date: 'dd/MM/yyyy HH:mm:ss'}}
                        </div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Tempo do processamento: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.tempoProcessamento}}ms</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Tempo de conversão: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.tempoConversao}}ms</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Versão do prisma: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.versaoPrisma}}</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Quantidade de páginas: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.quantidadePaginas}}</div>
                      </div>
                      <div class="p-grid">
                        <div class="p-col-4 p-text-bold">Quantidade de imagens: </div>
                        <div class="p-col-8">{{processoDocumento.arquivo.quantidadeImagens}}</div>
                      </div>
                    </div>
                  </p-tabPanel>

                  <p-tabPanel header="Texto" [disabled]="!processoDocumento.processado">
                    <div class="processo-documento-texto">
                      <div [innerText]="processoDocumentoTexto" *ngIf="processoDocumento.processado"></div>
                      <div *ngIf="!processoDocumento.processado">
                        <span class="fa pi-exclamation-triangle pendente"></span> O texto do documento ainda não foi
                        extraído.
                      </div>
                    </div>
                  </p-tabPanel>

                  <p-tabPanel header="Original">
                    <app-arquivo-visualizador [arquivo]="processoDocumentoArquivo"></app-arquivo-visualizador>
                  </p-tabPanel>
                </p-tabView>
              </div>
            </div>
          </div>
        </p-card>
      </p-tabPanel>

      <p-tabPanel header="Movimentos" leftIcon="pi pi-chart-line">
        <div class="p-field">
          <app-processo-visualizador-dados-documento #dlgVlzDadosMovimento> </app-processo-visualizador-dados-documento>
        </div>
        <div class="p-fluid p-grid">
          <div class="p-col-12 p-lg-12">
            <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsMovimento && dsMovimento.restricoes">
              <div class="p-fluid p-formgrid p-grid" (keyup)="dsMovimento.onEnterPesquisar($event)">
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-number label="Id" [restricao]="dsMovimento.restricoes.atributo('id')"></m-restricao-number>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Origem Id" [restricao]="dsMovimento.restricoes.atributo('origemId')"></m-restricao-string>
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <m-restricao-temporal label="Data" [restricao]="dsMovimento.restricoes.atributo('data')"></m-restricao-temporal>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Tipo" [restricao]="dsMovimento.restricoes.atributo('tipo.nome')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Descrição" [restricao]="dsMovimento.restricoes.atributo('descricao')"></m-restricao-string>
                </div>
                <div class="p-field p-col-12">
                  <m-restricao-string label="Hierarquia" [restricao]="dsMovimento.restricoes.atributo('tipo.hierarquia')"></m-restricao-string>
                </div>
              </div>
              <ng-template pTemplate="footer">
                <div class="p-fluid p-grid" style="padding-top: 1rem;">
                  <div class="p-field p-col-6">
                    <button pButton label="Pesquisar" (click)="dsMovimento.pesquisar()"></button>
                  </div>
                  <div class="p-field p-col-6">
                    <button pButton class="p-button-secondary" label="Limpar" (click)="dsMovimento.limpar()"></button>
                  </div>
                </div>
              </ng-template>
            </p-panel>
          </div>
        </div>
        <p-table
          *ngIf="dsMovimento !== undefined"
          [multiSortMeta]="dsMovimento.ordenacoes"
          [value]="dsMovimento.entidades" dataKey="id"
          [totalRecords]="dsMovimento.total"
          (onLazyLoad)="dsMovimento.carregar($event)"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50, 100]"
          paginatorPosition = "bottom"
          [lazy]="true"
          [(rows)]="dsMovimento.registros"
          [paginator]="true"
          responsiveLayout="scroll"
          responsive="true"
          sortMode="multiple"
          styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 5rem"></th>
              <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
              <th pSortableColumn="data" style="width: 250px">Data <p-sortIcon field="data"></p-sortIcon></th>
              <th pSortableColumn="tipo">Tipo <p-sortIcon field="tipo"></p-sortIcon></th>
              <th style="width: 7rem;">Ação</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-movimento let-expanded="expanded">
            <tr>
              <td>
                <button type="button" pButton pRipple [pRowToggler]="movimento" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
              </td>
              <td class="p-text-center">
               <app-id
                  [id]="movimento.id"
                  [origemId]="movimento.origemId">
                </app-id>
              </td>
              <td>
                <span>{{movimento.data | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
                <br />
                <span *ngIf="movimento.dataExclusao" class="exclusao">Excluído em: {{movimento.dataExclusao | date:
                  'dd/MM/yyyy HH:mm:ss'}}</span>
              </td>
              <td class="p-text-break">
                <strong>
                  <a [routerLink]="['/tipoMovimento/visualizar', movimento.tipo.id]"> {{movimento.tipo.id}}  - {{movimento.tipo.nome}} </a>
                </strong>
                <br>
                <div *ngIf="movimento.tipo.id === -1 && movimento.tipoMovimentoRecebidoId !== null">Id recebido: {{movimento.tipoMovimentoRecebidoId}}</div>

                {{movimento.descricao}}
              </td>
              <td class="p-text-center">
                 <span *ngIf="movimento.documento">
                  <button
                    pButton pRipple
                    type="button"
                    icon="pi pi-id-card"
                    class="p-button-rounded p-button-success p-button-outlined"
                    pTooltip="Visualizar documento"
                    (click)="dlgVlzDadosMovimento.visualizarDadosDocumentos(movimento.documento,processo)">
                  </button>
                </span>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="rowexpansion" let-movimento>
            <tr *ngIf="!movimento.classe">
              <td colspan="7" >
                <span>Não existe <strong>classe</strong> para o movimento {{movimento.id}}</span>
              </td>
            </tr>
            <tr *ngIf="movimento.classe">
              <td colspan="7">
                <p-fieldset legend="Dados da Classe">
                  <table  class="table-person">
                    <tr>
                      <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
                      <th>Data Início</th>
                      <th>Data Fim</th>
                      <th>Classe</th>
                    </tr>
                    <tr>
                      <td class="p-text-center">
                        <app-id
                          [id]="movimento.classe.id"
                          [origemId]="movimento.classe.origemId">
                        </app-id>
                      </td>
                      <td>{{movimento.classe.dataInicio | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                      <td>{{movimento.classe.dataFim | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                      <td>
                        <a [routerLink]="['/classe/visualizar', movimento.classe.classe.id]" class="cursor-pointer"> {{movimento.classe.classe.descricao}} </a>
                        <br />
                        <div *ngIf="movimento.classe.id === -1 && movimento.classe.classeRecebidaId !== null">Id recebido: {{movimento.classe.classeRecebidaId}}</div>
                      </td>
                    </tr>
                  </table>
                </p-fieldset>
              </td>
            </tr>

            <tr *ngIf="!movimento.distribuicao">
              <td colspan="7">
                <span>Não existe <strong>distribuição</strong> para o movimento {{movimento.id}}</span>
              </td>
            </tr>
            <tr *ngIf="movimento.distribuicao">
              <td colspan="7">
                <p-fieldset legend="Dados da Distribuição">
                  <table  class="table-person">
                    <tr>
                      <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
                      <th>Data Início</th>
                      <th>Data Fim</th>
                      <th *ngIf="isSegundoGrau()">Colegiado</th>
                      <th>Órgão Julgador</th>
                    </tr>
                    <tr>
                      <td class="p-text-center">
                        <app-id
                          [id]="movimento.distribuicao.id"
                          [origemId]="movimento.distribuicao.origemId">
                        </app-id>
                      </td>
                      <td>{{movimento.distribuicao.dataInicio | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                      <td>{{movimento.distribuicao.dataFim | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                      <td *ngIf="isSegundoGrau()">
                        <a [routerLink]="['/orgaoJulgadorColegiadoLocal/visualizar/', movimento.distribuicao.orgaoJulgadorColegiadoLocal.id]">
                          {{movimento.distribuicao?.orgaoJulgadorColegiadoLocal?.nome}}
                        </a>
                      </td>
                      <td>
                          <span *ngIf="movimento.distribuicao.orgaoJulgador.id === -1">
                             <a [routerLink]="['/orgaoJulgadorLocal/visualizar/', movimento.distribuicao.orgaoJulgadorLocal.id]">
                               {{movimento.distribuicao.orgaoJulgadorLocal.nome}}
                            </a>
                          </span>
                        <span *ngIf="movimento.distribuicao.orgaoJulgador.id !== -1">
                             <a [routerLink]="['/orgaoJulgador/visualizar/', movimento.distribuicao.orgaoJulgador.id]">
                               {{movimento.distribuicao.orgaoJulgador.nome}}
                            </a>
                          </span>
                      </td>
                    </tr>
                  </table>
                </p-fieldset>
              </td>
            </tr>
            <tr *ngIf="!movimento.complementos || movimento.complementos.length === 0">
              <td colspan="7" >
                <span>Não existe <strong>complementos</strong> para o movimento {{movimento.id}}</span>
              </td>
            </tr>
            <tr *ngIf="movimento.complementos && movimento.complementos.length > 0 ">
              <td colspan="7">
                <p-fieldset legend="Dados de complementos">
                  <p-table [value]="movimento.complementos" styleClass="custom-table">
                    <ng-template pTemplate="header">
                      <tr>
                        <th rowspan="2" class="p-text-center" style="width: 155px;">
                          <app-rotulo></app-rotulo>
                        </th>
                        <th colspan="3" style="text-align: center">Tipo</th>
                        <th rowspan="2">Tabelado</th>
                        <th rowspan="2">Valor</th>
                      </tr>
                      <tr><th>Categoria</th><th>Descrição</th><th>Observação</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-complemento>
                      <tr>
                        <td class="p-text-center">
                          <span *ngIf="!complemento.dataExclusao">
                            <app-id
                              [id]="complemento.id"
                              [origemId]="complemento.origemId">
                            </app-id>
                          </span>
                          <span *ngIf="complemento.dataExclusao">
                            <i class="pi pi-exclamation-circle person-exclamation" pTooltip="Excluído em: {{complemento.dataExclusao | date:'dd/MM/yyyy HH:mm:ss'}}"></i>
                            &nbsp;
                             <span class="p-text-taxado">
                              <app-id
                                [id]="complemento.id"
                                [origemId]="complemento.origemId">
                              </app-id>
                            </span>
                          </span>
                        </td>
                        <td>{{complemento.tipo.categoria}}</td>
                        <td>
                          <a [routerLink]="['/tipoComplemento/visualizar/', complemento?.tipo?.id]">{{complemento.tipo.descricao}}</a>
                        </td>
                        <td>{{complemento.tipo.observacao}}</td>
                        <td>{{complemento?.tabelado?.descricao}}</td>
                        <td>{{complemento.valor}}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-fieldset>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Partes" leftIcon="pi pi-users">
        <div class="p-fluid p-grid">
          <div class="p-col-12 p-lg-12">
            <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsParte && dsParte.restricoes">
              <div class="p-fluid p-formgrid p-grid" (keyup)="dsParte.onEnterPesquisar($event)">
                <div class="p-field p-col-12 p-md-6">
                  <m-restricao-number label="Id" [restricao]="dsParte.restricoes.atributo('id')"></m-restricao-number>
                </div>
                <div class="p-field p-col-12 p-md-6">
                  <m-restricao-string label="Origem Id" [restricao]="dsParte.restricoes.atributo('origemId')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Nome" [restricao]="dsParte.restricoes.atributo('pessoa.nome')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Tipo" [restricao]="dsParte.restricoes.atributo('tipoParte.nome')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <label class="m-l-8">Polo:</label>
                  <p-dropdown
                    placeholder="Selecione..." [options]="partesItens"
                    [(ngModel)]="dsParte.restricoes.atributo('polo').valor"
                    class="p-dropdown-p"
                    filter="true">
                  </p-dropdown>
                </div>
              </div>
              <ng-template pTemplate="footer">
                <div class="p-fluid p-grid" style="padding-top: 1rem;">
                  <div class="p-field p-col-6">
                    <button pButton label="Pesquisar" (click)="dsParte.pesquisar()"></button>
                  </div>
                  <div class="p-field p-col-6">
                    <button pButton class="p-button-secondary" label="Limpar" (click)="dsParte.limpar()"></button>
                  </div>
                </div>
              </ng-template>
            </p-panel>
          </div>
        </div>
        <p-table
          *ngIf="dsParte !== undefined"
          dataKey="id"
          [multiSortMeta]="dsParte.ordenacoes"
          [value]="dsParte.entidades"
          [totalRecords]="dsParte.total"
          (onLazyLoad)="dsParte.carregar($event)"
          [lazy]="true"
          [(rows)]="dsParte.registros"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,25,50,100]"
          paginatorPosition = "bottom"
          [paginator]="true"
          responsive="true"
          sortMode="multiple"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped"
          emptyMessage="Nenhum registro encontrado">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 5rem"></th>
              <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
              <th>Nome </th>
              <th>Tipo Pessoa</th>
              <th>Tipo</th>
              <th>Situação</th>
              <th pSortableColumn="polo">Polo <p-sortIcon field="pessoa.nome"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-parte let-expanded="expanded">
            <tr>
              <td>
                <button type="button" pButton pRipple [pRowToggler]="parte" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
              </td>
              <td class="p-text-center">
                <app-id
                  [id]="parte.id"
                  [origemId]="parte.origemId">
                </app-id>
              </td>
              <td>
                <a [routerLink]="['/pessoa/visualizar/', parte.pessoa.id]">{{parte.pessoa.nome}}</a>
              </td>
              <td class="p-text-center">
                <div class="p-col-12 p-lg-10">{{parte.pessoa.tipo | dominio:'getTipoPessoa'}}</div>
              </td>
              <td class="text-left">
                <a [routerLink]="['/tipoParte/visualizar/', parte.tipo.id]">
                  {{parte.tipo.nome}}
                </a>
              </td>
              <td class="p-text-center">
                <span [ngClass]="parte.situacao === 'ATIVO' ? 'badge badge-success' : parte.situacao === 'INATIVO' ? 'badge badge-danger' :
                      parte.situacao === 'SUSPENSO' ? 'badge badge-danger' : parte.situacao === 'BAIXADO' ? 'badge badge-blue' : ''">
                     {{parte.situacao | dominio:'getPartesSituacao'}}
                </span>
              </td>
              <td class="text-left">
                {{parte.polo | dominio:'getPolos'}}
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="rowexpansion" let-parte>
            <tr>
              <td colspan="9">
                <p-fieldset legend="Dados de Representantes">
                  <div *ngIf="!parte.representantes.length">
                    <p style="margin: 0">Não possui <strong>Dados de Representantes</strong></p>
                  </div>
                  <p-table *ngIf="parte.representantes.length > 0" [value]="parte.representantes">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
                        <th>Representante</th>
                        <th style="width: 150px">Tipo</th>
                        <th style="width: 100px">Enviar Intimação</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-representante>
                      <tr>
                        <td class="p-text-center">
                          <app-id
                            [id]="representante.id"
                            [origemId]="representante.origemId">
                          </app-id>
                        </td>
                        <td>
                          <a style="display: block" [routerLink]="['/pessoa/visualizar/', representante.representante.id]">
                            {{representante.representante.nome}}
                          </a>
                          <span *ngIf="representante.dataExclusao" style="color: #b70000; font-style: italic; font-size: 0.8em;">
                            Excluído em: {{ representante.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss' }}
                          </span>
                        </td>
                        <td>
                            {{ representante.tipo }}
                        </td>
                        <td>
                          {{ representante.enviarIntimacao ? 'Sim' : 'Não' }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-fieldset>

                <p-fieldset legend="Dados de Relacionamentos">
                  <div *ngIf="!parte.relacionamentos.length">
                    <p style="margin: 0">Não possui <strong>Dados de Relacionamentos</strong></p>
                  </div>
                  <p-table *ngIf="parte.relacionamentos.length > 0" [value]="parte.relacionamentos">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
                        <th>Relacionada</th>
                        <th style="width: 150px">Tipo</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-relacionamento>
                      <tr>
                        <td class="p-text-center p-text-break">
                          <app-id
                            [id]="relacionamento.id"
                            [origemId]="relacionamento.origemId">
                          </app-id>
                        </td>
                        <td>
                          <a style="display: block" [routerLink]="['/pessoa/visualizar/', relacionamento.relacionada.id]">
                            {{ relacionamento.relacionada.nome }}
                          </a>
                          <span *ngIf="relacionamento.dataExclusao" style="color: #b70000; font-style: italic; font-size: 0.8em;">
                            Excluído em: {{ relacionamento.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss' }}
                          </span>
                        </td>
                        <td>
                          {{ relacionamento.tipo }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-fieldset>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Relacionamentos" leftIcon="pi pi-globe">
        <div class="p-fluid p-grid">
          <div class="p-col-12 p-lg-12">
            <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true"  *ngIf="dsRelacionamento && dsRelacionamento.restricoes">
              <div class="p-fluid p-formgrid p-grid" (keyup)="dsRelacionamento.onEnterPesquisar($event)">
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-number label="Id" [restricao]="dsRelacionamento.restricoes.atributo('id')"></m-restricao-number>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Origem Id" [restricao]="dsRelacionamento.restricoes.atributo('origemId')"></m-restricao-string>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Classe" [restricao]="dsRelacionamento.restricoes.atributo('classe.descricao')"></m-restricao-string>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Número" [restricao]="dsRelacionamento.restricoes.atributo('numeroProcesso')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <label class="m-l-8">Tipo:</label>
                  <p-dropdown
                    placeholder="Selecione..." [options]="tipoRelacionamentoItens"
                    [(ngModel)]="dsRelacionamento.restricoes.atributo('tipo').valor"
                    class="p-dropdown-p"
                    filter="true">
                  </p-dropdown>
                </div>
              </div>
              <ng-template pTemplate="footer">
                <div class="p-fluid p-grid" style="padding-top: 1rem;">
                  <div class="p-field p-col-6">
                    <button pButton label="Pesquisar" (click)="dsRelacionamento.pesquisar()"></button>
                  </div>
                  <div class="p-field p-col-6">
                    <button pButton class="p-button-secondary" label="Limpar" (click)="dsRelacionamento.limpar()"></button>
                  </div>
                </div>
              </ng-template>
            </p-panel>
          </div>
        </div>
        <p-table *ngIf="dsRelacionamento !== undefined"
                 [value]="dsRelacionamento.entidades"
                 [multiSortMeta]="dsRelacionamento.ordenacoes"
                 [totalRecords]="dsRelacionamento.total"
                 (onLazyLoad)="dsRelacionamento.carregar($event)"
                 [lazy]="true"
                 [(rows)]="dsRelacionamento.registros"
                 currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
                 [showCurrentPageReport]="true"
                 [rowsPerPageOptions]="[10,25,50,100]"
                 paginatorPosition = "bottom"
                 [paginator]="true"
                 responsive="true"
                 sortMode="multiple"
                 responsiveLayout="scroll"
                 styleClass="p-datatable-striped"
                 emptyMessage="Nenhum registro encontrado">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-text-center" style="width: 150px;"> <app-rotulo></app-rotulo></th>
              <th pSortableColumn="tipo">Tipo <p-sortIcon field="tipo"></p-sortIcon></th>
              <th>Classe</th>
              <th>Número</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5">
                Nenhum registro encontrado
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-processoRelacionamento>
            <tr>
              <td class="p-text-center">
                <app-id
                  [id]="processoRelacionamento.id"
                  [origemId]="processoRelacionamento.origemId">
                </app-id>

              </td>
              <td>
                {{processoRelacionamento.tipo | dominio:'getRelacionamentoTipo'}}
              </td>
              <td>{{processoRelacionamento.classe.descricao}}</td>
              <td>
                <span *ngIf="!processoRelacionamento.relacionado">
                  {{processoRelacionamento.numeroProcesso}}
                </span>
                <a *ngIf="processoRelacionamento.relacionado"
                   [href]="'/processo/historico/' + processoRelacionamento.relacionado.id"
                   title="Visualizar o processo">
                  {{processoRelacionamento.numeroProcesso}}
                </a>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="Auditoria" leftIcon="pi pi-search">
        <div class="p-fluid">
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Data:</div>
            <div class="p-col-12 p-lg-9">{{processo?.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Usuário:</div>
            <div class="p-col-12 p-lg-9">{{processo?.auditoriaUsuarioInsercao?.nome}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Data:</div>
            <div class="p-col-12 p-lg-9">{{processo?.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Usuário:</div>
            <div class="p-col-12 p-lg-9">{{processo?.auditoriaUsuario?.nome}}</div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</p-card>
